<template>
    <b-table
            :narrowed="true"
            :striped="true"
            :data="data"
    >
     <template slot-scope="props">
         <b-table-column label="ID" width="40" numeric field="id">{{props.row.id}}</b-table-column>
         <b-table-column label="Name" field="name">{{props.row.name}}</b-table-column>
         <b-table-column label="Floor" field="floor_name" width="80">{{props.row.floor_name}}</b-table-column>
         <b-table-column label="Bedroom ?" field="bedroom_role" width="100" centered>{{props.row.bedroom_role}}</b-table-column>
         <b-table-column label="Temperature ?" field="temperature_sensor" width="140" centered>{{props.row.temperature_sensor}}</b-table-column>
         <b-table-column label="Motion ?" field="motion_detector" width="100" centered>{{props.row.motion_detector}}</b-table-column>
     </template>
    </b-table>
</template>

<script>
  import BTableColumn from "buefy/src/components/table/TableColumn";

  export default {
    components: {BTableColumn},
    name: "room-list",
    props: ['rooms'],
    computed: {
      data() {
        if (!this.rooms) {
          return [];
        }

        return this.rooms;
      }
    }
  }
</script>

<style scoped>

</style>